export default from './DesktopMenu';



// WEBPACK FOOTER //
// ./src/layouts/NonAuthLayout/components/Menu/components/DesktopMenu/index.js